// Лимиты заказа и настройки экрана аппарата. Задаются в веб-панели
// (KioskSettings на бэкенде) и приходят в GET /api/v1/payments/price.
// Последнее слово за create_payment — здесь только подсказка до оплаты.
// Часов работы на киоске нет: его выключает умная розетка, расписание
// видит только бот.

/**
 * Первое нарушенное ограничение заказа или null.
 * sheets — листов на весь заказ (с копиями), copies — максимум копий одного документа.
 */
export function limitMessage(priceApparat, { sheets, copies, documents }, t) {
    const limits = priceApparat?.kiosk_settings?.order_limits;
    if (!limits) return null;
    if (limits.max_documents != null && documents > limits.max_documents) {
        return t("apparatPolicy.limit_documents", { n: limits.max_documents });
    }
    if (limits.max_copies != null && copies > limits.max_copies) {
        return t("apparatPolicy.limit_copies", { n: limits.max_copies });
    }
    if (limits.max_sheets != null && sheets > limits.max_sheets) {
        return t("apparatPolicy.limit_sheets", { n: limits.max_sheets });
    }
    return null;
}

/** Таймауты «Вы ещё здесь?» из настроек экрана, с умолчаниями прежней версии. */
export function screenTimeouts(priceApparat) {
    const s = priceApparat?.kiosk_settings?.screen;
    const inactivity = Number(s?.inactivity_seconds);
    const countdown = Number(s?.inactivity_countdown_seconds);
    return {
        inactivityMs: (Number.isFinite(inactivity) && inactivity >= 30 ? inactivity : 180) * 1000,
        countdownSec: Number.isFinite(countdown) && countdown >= 5 ? countdown : 10,
    };
}
